/**
 * @generated SignedSource<<fbf854e81af62b13730930a63d6ea615>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type RelatedProductInput = {
  bundles: ReadonlyArray<RelatedProductBundleInput>;
  cartId?: string | null;
  channel?: CartChannel | null;
};
export type RelatedProductBundleInput = {
  id: string;
  items: ReadonlyArray<RelatedProductBundleItemInput>;
};
export type RelatedProductBundleItemInput = {
  id: string;
};
export type PaymentOptionsQuery$variables = {
  input: RelatedProductInput;
};
export type PaymentOptionsQuery$data = {
  readonly relatedIfp: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly description: string | null;
    readonly promotions: ReadonlyArray<{
      readonly shortDescription: string | null;
    }> | null;
  }>;
};
export type PaymentOptionsQuery = {
  variables: PaymentOptionsQuery$variables;
  response: PaymentOptionsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IfpOfferDetail",
    "kind": "LinkedField",
    "name": "relatedIfp",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortDescription",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentOptionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentOptionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "316e3f63e5ab5371154359ad0641f67a",
    "id": null,
    "metadata": {},
    "name": "PaymentOptionsQuery",
    "operationKind": "query",
    "text": "query PaymentOptionsQuery(\n  $input: RelatedProductInput!\n) {\n  relatedIfp(input: $input) {\n    id\n    name\n    description\n    promotions {\n      shortDescription\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34a2bb4828a9934bc1ab577b584fcc8f";

export default node;
